export enum ProofIncomeMethodsEnumeration {
  OPENBANKING = 'OPENBANKING',
  TGSS = 'TGSS',
}
